"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ErrorOidcHandler = void 0;
const solid_client_authn_core_1 = require("@inrupt/solid-client-authn-core");
const SessionInfoManager_1 = require("../../../sessionInfo/SessionInfoManager");
class ErrorOidcHandler {
    async canHandle(redirectUrl) {
        try {
            return new URL(redirectUrl).searchParams.has("error");
        }
        catch (e) {
            throw new Error(`[${redirectUrl}] is not a valid URL, and cannot be used as a redirect URL: ${e.toString()}`);
        }
    }
    async handle(redirectUrl, eventEmitter) {
        if (eventEmitter !== undefined) {
            const url = new URL(redirectUrl);
            const errorUrl = url.searchParams.get("error");
            const errorDescriptionUrl = url.searchParams.get("error_description");
            eventEmitter.emit(solid_client_authn_core_1.EVENTS.ERROR, errorUrl, errorDescriptionUrl);
        }
        return SessionInfoManager_1.getUnauthenticatedSession();
    }
}
exports.ErrorOidcHandler = ErrorOidcHandler;
//# sourceMappingURL=ErrorOidcHandler.js.map